(function () {
    "use strict";
    // !! With JCU-V1 Header redevelopment, JCU Pages not using the new platform require Header CSS/JS to be loaded
    // !! To Prevent having users having load the entire JCU-V1 CSS/JS just for the header, these files are built in webpack.common.js again in a seperate legacy file.

    // ? For Legacy support, if jcu_js_v1 is not defined, define again as _global/global.js is not within bundle
    if (!jcu_js_v1) {
        // Global variables
        var jcu_js_v1 = {
            fn: {},
            vars: {},
        };
    }

    jcu_js_v1.vars.isHome = false;

    jcu_js_v1.fn.initHeader = function () {
        var scrollHeight = 64;

        // Set list of allowed web paths that allow shadow Home style, and add class to header
        var allowedPathNames = ["/", "/_nocache", "/_recache"];
        if (allowedPathNames.indexOf(window.location.pathname) >= 0)
            jcu_js_v1.vars.isHome = true;

        // If page is the homepage run funcs...
        if (jcu_js_v1.vars.isHome) {
            document.body.classList.add("page-home");
        }

        // Detch page scroll position immediately before Intersect Observer/EventListener exists (page-top and page-home are applied in Design Customisation #1077776)
        if (window.scrollY > scrollHeight) {
            document.body.classList.remove("page-top");
        } else {
            document.body.classList.add("page-top");
        }

        // setup Intersection Observer (If supported) to watch page scroll position
        if (
            "IntersectionObserver" in window &&
            "IntersectionObserverEntry" in window &&
            "intersectionRatio" in window.IntersectionObserverEntry.prototype
        ) {
            let observer = new IntersectionObserver((entries) => {
                if (
                    entries[0].boundingClientRect.y < 0 &&
                    window.innerWidth > 768
                ) {
                    document.body.classList.remove("page-top");
                } else {
                    document.body.classList.add("page-top");
                }
            });

            // Attach Observer to Skip links
            observer.observe(document.querySelector("#page-top-hook"));
        } else {
            // Intersection Observer NOT Supported, use debounced scroll eventListener fallback
            // (debounced) Add Continous event Listener to handle scroll during page visit
            window.addEventListener("scroll", function () {
                // window.addEventListener("scroll", jcu_js_v1.fn.debounce(function(){
                if (!document.body.classList.contains("search-active")) {
                    if (window.pageYOffset > scrollHeight) {
                        document.body.classList.remove("page-top");
                    } else {
                        document.body.classList.add("page-top");
                    }
                }
                // }, 66));
            });
        }

        //New for the Radio buttons
        // Add an event listener to the form to handle form submission
        document
            .querySelector("form")
            .addEventListener("submit", function (event) {
                // Prevent the default form submission behavior to handle the search redirection manually
                event.preventDefault();

                // Check if the searchRadios group exists
                var searchRadios = document.getElementsByName("searchRadios");
                if (!searchRadios.length) {
                    // Handle the case where the searchRadios group doesn't exist or has no elements
                    // For example, you can display an error message or log a message in the console.
                    return;
                }

                // Get the selected search radio button's value and the data-url attribute
                var selectedRadioValue;
                var coursePageUrl;
                for (var i = 0; i < searchRadios.length; i++) {
                    if (searchRadios[i].checked) {
                        selectedRadioValue = searchRadios[i].value;
                        coursePageUrl =
                            searchRadios[i].getAttribute("data-url"); // Get the value of data-url attribute
                        break;
                    }
                }

                // Get the search query from the input field
                var query = document.getElementById("search-query").value;

                // Check if the "Search courses" radio button is selected and a query is provided
                if (selectedRadioValue === "searchCourse" && query) {
                    // Redirect to the course page with the search query added to the URL
                    var urlWithQuery =
                        coursePageUrl + "?query=" + encodeURIComponent(query);
                    window.location.href = urlWithQuery;
                } else {
                    // Handle other search scenarios if needed
                    // For example, you can handle the "Search all content" option differently here.
                    // Otherwise, you can let the form submit normally to the default "/search" action.
                    event.target.submit();
                }
            });

        // Add event listeners to radio buttons to check/uncheck them dynamically
        var searchRadios = document.getElementsByName("searchRadios");
        for (var i = 0; i < searchRadios.length; i++) {
            searchRadios[i].addEventListener("change", function () {
                // Uncheck all radio buttons first
                for (var j = 0; j < searchRadios.length; j++) {
                    searchRadios[j].removeAttribute("checked");
                }
                // Check the selected radio button
                this.setAttribute("checked", "");
            });
        }

        // Handle Header Popup Search/Mobile Menu
        document
            .querySelector(".jcu-v1__menu__search__btn")
            .addEventListener("click", function () {
                // Configure <body> classes appropriately
                if (document.body.classList.contains("page-top")) {
                    document.body.classList.remove("page-top");
                }

                if (document.body.classList.contains("search-active")) {
                    document.body.classList.remove("search-active");

                    if (window.scrollY < scrollHeight) {
                        document.body.classList.add("page-top");
                    }
                } else {
                    //   Open search modal
                    document.body.classList.add("search-active");

                    // If user is not mobile, change text focus
                    if (window.innerWidth > 768) {
                        document.querySelector("#search-query").focus();
                    }
                }
            });
    };

    jcu_js_v1.fn.initHeader();

    // Remove scroll event from window that applys 'sticky' to page-wrapper
    document.addEventListener("DOMContentLoaded", function () {
        $(window).unbind("scroll");
        document.querySelector("#page-wrapper").classList.remove("sticky");
    });
})();

// !! Old JCU JS Hover/dropdown for menu items
(function () {
    "use strict";

    var delay = function delay(elem, callback) {
        var timeout = null;
        var dropMenu = elem.lastElementChild;
        var list = traverseChildren(elem); //console.log('list ', list);

        elem.onmouseover = function () {
            // Set timeout to be a timer which will invoke callback after 1s
            timeout = setTimeout(function () {
                elem.classList.add("hover");
            }, 375);
        };

        elem.onmouseout = function (event) {
            // Clear any timers set to timeout
            clearTimeout(timeout);
            var e = event.toElement || event.relatedTarget; //console.log('Event ', e);

            if (!!~list.indexOf(e)) {
                return;
            } else {
                elem.classList.remove("hover");
            }
        };
    };

    function traverseChildren(elem) {
        var children = [];
        var q = [];
        q.push(elem);

        while (q.length > 0) {
            var elem = q.pop();
            children.push(elem);
            pushAll(elem.children);
        }

        function pushAll(elemArray) {
            for (var i = 0; i < elemArray.length; i++) {
                q.push(elemArray[i]);
            }
        }

        return children;
    }

    var mnu = document
        .getElementById("main-navigation")
        .querySelectorAll(".jcu-v1__l1_wrap");

    for (var i = 0; i < mnu.length; i++) {
        mnu[i].addEventListener(
            "mouseover",
            function (event) {
                //event.preventDefault();
                var evt = event || window.event;
                var source = event.srcElement;
                delay(this, function () {});
            },
            true
        );
    }
})();
